const preferencesTypes = {
  RESOURCE_COLUMNS_SET: 'RESOURCE_COLUMNS_SET',
  RESOURCE_FIELDS_SET: 'RESOURCE_FIELDS_SET',
  RESOURCE_DATA_SET: 'RESOURCE_DATA_SET',
  OPTIONS_SET: 'OPTIONS_SET',
};
export default preferencesTypes;
